import "core-js/modules/es.regexp.flags";
import { connect } from 'react-redux';
import { saveOffer, userProfile } from 'redux/saga/entities/bound';
import modal from 'decorators/Modal/Modal';
import { SUBSCRIPTION_CHANGE_REQUEST, acceptSaveOffer, closeSaveOffer } from './saveOffer.saga';
import { SaveOffer } from './components/SaveOffer';
export var modalConfig = {
  headerClass: 'modal__save-offer',
  lightClose: true
};
export var mapStateToProps = function mapStateToProps(state) {
  var _ref = saveOffer.data(state) || {},
      credits = _ref.credits_per_cycle,
      currencyCode = _ref.currency_code,
      price = _ref.price,
      rolloverCredits = _ref.rollover_credits;

  var _ref2 = userProfile.data(state) || {},
      firstName = _ref2.first_name;

  return {
    credits: credits,
    currencyCode: currencyCode,
    loading: state.page.flags[SUBSCRIPTION_CHANGE_REQUEST],
    name: firstName,
    price: price,
    rolloverCredits: rolloverCredits
  };
};
export var mapDispatchToProps = {
  onAccept: acceptSaveOffer,
  onModalClose: closeSaveOffer
};
var SaveOfferModalContainer = connect(mapStateToProps, mapDispatchToProps)(modal(modalConfig)(SaveOffer));
export { SaveOfferModalContainer };